module.exports = __webpack_public_path__ + "static/media/icn-results.5630bfc2.svg";